import PlayerStateManagementList from './player-state-management.list';
import PlayerStateManagementShow from './player-state-management.show';

export default {
  list: PlayerStateManagementList,
  show: PlayerStateManagementShow,
};
